import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'client/payments';

export const create = async (form) => {
  return await fetchWrapper.post(baseUrl, form);
}
export const get = async (filters) => {
  const url = `${baseUrl}?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}
export const download = async (id) => {
  const url = `${baseUrl}/${id}/download`;
  return await fetchWrapper.get(url);
}